import * as React from "react";
import { Dialog, DialogFooter, DialogType } from "office-ui-fabric-react/lib/Dialog";
import { PrimaryButton } from "office-ui-fabric-react/lib/Button";

const dialogStyles = { main: { maxWidth: 450 } };

interface IDialogBoxProps {
  title?: string;
  subTitle?: string;
  hideDialog: boolean;
  agendaUrl?: string;
  toggleHideDialog: (agendaUrl?: string) => void;
}

export function DialogBox(props: IDialogBoxProps) {
  const { hideDialog, title, subTitle, toggleHideDialog, agendaUrl } = props;
  return (
    <Dialog
      hidden={hideDialog}
      onDismiss={() => toggleHideDialog()}
      dialogContentProps={{
        type: DialogType.normal,
        title: title || "",
        closeButtonAriaLabel: "Close",
        subText: subTitle || "",
      }}
      modalProps={{
        styles: dialogStyles,
      }}
    >
      <DialogFooter>
        <PrimaryButton onClick={() => toggleHideDialog(agendaUrl)} text="OK" />
      </DialogFooter>
    </Dialog>
  );
}
